import React from 'react';
import GamificationServices from '../services/GamificationServices';
import TierBadge from './TierBadge';

const LevelProgressCard = ({ profile }) => {
  if (!profile) {
    return (
      <div className="gamification-card">
        <div className="card-header">
          <h3 className="card-title">
            <i className="las la-layer-group"></i>
            Nível Atual
          </h3>
        </div>
        <div className="loading-container" style={{ padding: '2rem' }}>
          <div className="loading-text">Carregando...</div>
        </div>
      </div>
    );
  }

  const { current_level, next_level_progress, tier_info, level_benefits } = profile;
  const progressPercentage = next_level_progress?.percentage || 0;
  const timeToNext = GamificationServices.calculateTimeToNextLevel(
    next_level_progress?.current || 0, 
    next_level_progress?.needed || 1
  );

  return (
    <div className="gamification-card pulse-animation">
      <div className="card-header">
        <h3 className="card-title">
          <i className="las la-layer-group"></i>
          Nível Atual
        </h3>
        <TierBadge tier={tier_info} size="sm" />
      </div>

      <div className="level-display">
        <div className="level-number">{current_level}</div>
        <div className="level-label">Nível Atual</div>
        
        {next_level_progress && (
          <>
            <div className="progress-container">
              <div className="progress-header">
                <span className="progress-label">Progresso para o próximo nível</span>
                <span className="progress-value">
                  {GamificationServices.formatXP(next_level_progress.current)} / {GamificationServices.formatXP(next_level_progress.needed)}
                </span>
              </div>
              <div className="progress-bar">
                <div 
                  className="progress-fill" 
                  style={{ width: `${Math.min(progressPercentage, 100)}%` }}
                ></div>
              </div>
              <div style={{ textAlign: 'center', marginTop: '0.5rem', fontSize: '0.8rem', color: 'var(--text-muted)' }}>
                {progressPercentage.toFixed(1)}% • Tempo estimado: {timeToNext}
              </div>
            </div>
          </>
        )}
      </div>

      {level_benefits && level_benefits.benefits && level_benefits.benefits.length > 0 && (
        <div style={{ marginTop: '0.75rem' }}>
          <h4 style={{ fontSize: '0.8rem', fontWeight: '600', marginBottom: '0.5rem', color: 'var(--text-primary)' }}>
            Benefícios do seu nível:
          </h4>
          <ul style={{ margin: 0, paddingLeft: '1rem', fontSize: '0.7rem', color: 'var(--text-muted)', lineHeight: '1.4' }}>
            {level_benefits.benefits.slice(0, 2).map((benefit, index) => (
              <li key={index} style={{ marginBottom: '0.25rem', wordBreak: 'break-word' }}>
                {benefit}
              </li>
            ))}
            {level_benefits.benefits.length > 2 && (
              <li style={{ fontStyle: 'italic', color: 'var(--primary)' }}>
                +{level_benefits.benefits.length - 2} outros benefícios...
              </li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default LevelProgressCard;